module.exports = __webpack_public_path__ + "static/media/g-16.4830f108.jpg";